import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ProtectionRiskType } from "@bienesis/common";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

import { useApi } from "../client";
import keys from "./keys";

export const useSetProtectionActivation = ({
  areaId,
  riskType,
}: {
  areaId: string;
  riskType: ProtectionRiskType;
}) => {
  const api = useApi();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const queryKey = keys.summary({ areaId, riskType });

  return useMutation({
    mutationFn: async (active: boolean) => {
      const endpoint = active ? "start" : "stop";
      const response = await api.post(
        `protection/${areaId}/${riskType}/${endpoint}`
      );
      return response.json();
    },
    mutationKey: queryKey,
    onSuccess: async (_data, active) => {
      await Promise.all([
        // summary : observer monté (sheet settings/détail) → refetch pour
        // resynchroniser le Switch (piloté par activeSince).
        queryClient.invalidateQueries({ queryKey }),
        // active : la liste est démontée au moment du toggle, donc refetch
        // forcé (invalidate ne refetcherait pas une query sans observer).
        queryClient.refetchQueries({
          queryKey: keys.active(areaId),
          exact: true,
        }),
      ]);
      toast.success(t(active ? "protection.activated" : "protection.disabled"));
    },
    onError: () => {
      toast.error(t("protection.activationError"));
    },
  });
};
